<template lang="pug">
  section.category-posts.teaser-list.container(v-if="section.categories" :class="classes" :style="style")

    .horizontal(v-if="layout === 'horizontal'" ref="teasers")
      Spinner(v-if="loading" :size="10" :thickness="2")
      //- .teasers(v-if="loading")
      //-   .teaser.skeleton(v-for="teaser in teasers" :style="{ width: `${100 / perPage}%` }")
      //-     .image
      //-     .text
      .paginated-teasers(v-if="teasers.length")
        .teasers
          .teaser(v-for="teaser in teasers" :style="{ width: `${100 / perPage}%` }")
            Teaser(
              :page="teaser"
              :origin="section.id"
              display="card"
              :show-date="showDate"
              :show-topic="section.categories.length > 1"
              :optimize="optimize"
            )
        Pagination(
          v-if="pageInfo && pageInfo.lastPage > 1"
          :last-page="pageInfo.lastPage"
          :current-page="pageInfo.currentPage"
          nav-class="pagination is-rounded is-centered"
          @change="changePage"
        )
          template(v-slot:prev)
            span.icon
              i.fas.fa-arrow-left
          template(v-slot:next)
            span.icon
              i.fas.fa-arrow-right

    .vertical(v-else ref="teasere")
      .column.is-offset-1.is-10
        Spinner(v-if="loading" :size="10" :thickness="2")
        //- .teasers(v-if="loading")
        //-   .teaser.skeleton(v-for="teaser in teasers")
        //-     .image
        //-     .text
        .paginated-teasers(v-if="teasers.length")
          .teasers
            .teaser(v-for="teaser in teasers")
              Teaser(
                :page="teaser"
                :origin="section.id"
                display="row"
                :show-date="showDate"
                :show-topic="section.categories.length > 1"
                :optimize="optimize"
              )
        Pagination(
          v-if="pageInfo && pageInfo.lastPage > 1"
          :last-page="pageInfo.lastPage"
          :current-page="pageInfo.currentPage"
          nav-class="pagination is-rounded"
          @change="changePage"
        )
          template(v-slot:prev)
            span.icon
              i.fas.fa-arrow-left
          template(v-slot:next)
            span.icon
              i.fas.fa-arrow-right

</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import router from '@/router';
import { get, cloneDeep } from '@/helpers';

import Teaser from './Teaser';

import Pagination from '@/components/Pagination';

import section from '@/mixins/section';

export default {
  name: 'CategoryPosts',
  mixins: [section],
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    currentPage: 1,
    pages: undefined,
    loading: false
  }),
  components: {
    Teaser,
    Pagination
  },
  computed: {
    s() {
      return this.sections.findIndex(el => el.id === this.section.id);
    },
    perPage() {
      // default value
      let perPage = 10;

      if (this.layout === 'horizontal') {
        perPage = 4;
      } else if (this.settings.length) {
        const setting = this.settings.find(setting => setting.key === 'per_page');
        if (setting && setting.value !== undefined) perPage = parseInt(setting.value);
      }

      return perPage;
    },
    layout() {
      // default value
      let layout = 'vertical';

      if (this.settings.length) {
        const setting = this.settings.find(setting => setting.key === 'layout');
        if (setting && setting.value !== undefined) layout = setting.value;
      }

      return layout;
    },
    optimize() {
      let optimize = 'traffic';

      const config = this.settings.find(setting => setting.key === 'optimize-images');
      if (config) optimize = config.value;

      return optimize;
    },
    teasers() {
      let teasers = [];
      // if (this.loading) {
      //   if (this.layout === 'horizontal') teasers = new Array(this.perPage);
      //   else teasers = new Array(3);
      // } else {
      //   teasers = get(this.section, 'teasers.pagination.items');
      // }
      teasers = get(this.pages, 'items') || [];
      return teasers;
    },
    sort() {
      // default value
      let sort = { direction: 'desc', field: 'created_at' };

      const sortOrder = this.settings.find(setting => setting.key === 'sort_order') || {
        direction: 'desc',
        field: 'created_at'
      };
      switch (sortOrder.value) {
        case 'date_desc':
          sort = { direction: 'desc', field: 'created_at' };
          break;
        case 'date_asc':
          sort = { direction: 'asc', field: 'created_at' };
          break;
        case 'title_desc':
          sort = { direction: 'desc', field: 'title' };
          break;
        case 'title_asc':
          sort = { direction: 'asc', field: 'title' };
          break;
        default:
          sort = { direction: 'desc', field: 'created_at' };
          break;
      }

      return sort;
    },
    showDate() {
      const showDate = this.settings.find(setting => setting.key === 'show_date') || false;
      return ['true', '1', 'yes', true].includes(showDate.value);
    },
    pageInfo() {
      return get(this.pages, 'pageInfo');
    },
    ...mapGetters({
      sections: 'sections',
      cms: 'CMS',
      reference: 'reference'
    })
  },
  methods: {
    changePage(currentPage) {
      if (this.$refs.teasers) {
        this.$refs.teasers.scrollIntoView({
          behavior: 'smooth'
        });
      }

      if (currentPage > 1) {
        let query = {};
        query[`P${this.section.id}`] = currentPage;
        router.push({ query });
      } else {
        router.push({ query: null });
      }

      this.currentPage = currentPage;
      this.refetch();
    },
    refetch() {
      this.loading = true;

      const payload = {
        pageInfo: {
          currentPage: parseInt(this.currentPage),
          perPage: parseInt(this.perPage)
        },
        filters: [
          {
            key: 'section-selection',
            match: this.section.id
          }
        ],
        order: this.sort.field,
        direction: this.sort.direction
      };

      this.fetchTeasers(payload)
        .then(response => {
          if (response.pageInfo.currentPage > response.pageInfo.lastPage) {
            this.changePage(response.pageInfo.lastPage);
            return;
          }

          const pages = cloneDeep(response);
          if (pages.items && pages.items.length) {
            pages.items.forEach((page, i) => {
              page.position = i + 1;
            });
          }

          this.pages = pages;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // ...mapMutations({
    //   updateTeasersLoading: 'updateCategoryPostTeasersLoading',
    //   insertTeasers: 'insertTeasers'
    // }),
    ...mapActions({
      fetchTeasers: 'fetchCategoryPostTeasers'
    })
  },
  mounted() {
    const pages = { loading: true, pagination: {} };
    this.pages = pages;

    this.currentPage = get(this.$route, `query.P${this.section.id}`) || 1;
    this.refetch();
  }
};
</script>

<style lang="sass" scoped>
.teaser-list .pagination-container
  margin-top: 20px
  .pagination
    .pagination-previous,
    .pagination-next
      padding-left: 0.3em
      padding-right: 0.3em

.teaser-list .vertical .pagination-container
  margin-top: 50px

.spinner-container
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  z-index: 1
  background-color: rgba(238, 238, 241, 0.5)

.horizontal
  position: relative
  min-height: 40px
  .teasers
    text-align: center
    .teaser
      margin-bottom: 50px
      display: inline-block
      padding: 15px
      &:last-child
        margin-bottom: 10px
      // @include mobile
      //   width: 100% !important
      //   max-width: 360px
      //
    @screen md
      margin: -10px
      display: flex
      flex-direction: row
      justify-content: center
      .teaser
        // margin: 10px
        margin-bottom: 10px
        flex-grow: 0
        flex-shrink: 0

.vertical
  position: relative
  min-height: 40px
  .teasers
    text-align: center
    .teaser
      margin-bottom: 50px
      &:last-child
        margin-bottom: 10px
      // @screen mobile
      //   width: 100% !important
      //   max-width: 360px
      //   display: inline-block
</style>
